<div class="rule-view-container">
    <!-- <div class="header-wrapper py-5">
        <div class="header">
            <div class="header-col-1">
                <div class="header-col-1-1">
                    <span></span>
                </div>

                <div class="header-col-1-2">
                    <p class="content-l bolder primary-texts py-2 bold-text">{{rulevarservice.ruleMeta.headers[0]}}</p>
                    <span class="info-text span-l">{{rulevarservice.ruleStat?.ruleStat?.total ?
                        rulevarservice.ruleStat?.ruleStat?.total : '0'}}</span>
                </div>
            </div>

            <div class="header-col-2">
                <div class="header-col-2-1">
                    <span></span>
                </div>

                <div class="header-col-2-2">
                    <p class="content-l bolder primary-texts py-2 bold-text">{{rulevarservice.ruleMeta.headers[1]}}</p>
                    <span class="alt-text span-l">{{rulevarservice.ruleStat?.ruleStat?.active ?
                        rulevarservice.ruleStat?.ruleStat?.active : '0'}}</span>
                </div>
            </div>

            <div class="header-col-3">
                <div class="header-col-3-1">
                    <span></span>
                </div>

                <div class="header-col-3-2">
                    <p class="content-l bolder primary-texts py-2 bold-text">{{rulevarservice.ruleMeta.headers[2]}}</p>
                    <span class="magenta-text span-l">{{rulevarservice.ruleStat?.ruleStat?.inactive ?
                        rulevarservice.ruleStat?.ruleStat?.inactive : '0'}}</span>
                </div>
            </div>

            <div class="header-col-4">
                <div class="header-col-4-1">
                    <span></span>
                </div>

                <div class="header-col-4-2">
                    <p class="content-l bolder primary-texts py-2 bold-text">{{rulevarservice.ruleMeta.headers[3]}}</p>
                    <span class="info-text span-l">{{rulevarservice.ruleStat?.ruleStat?.compliance ?
                        rulevarservice.ruleStat?.ruleStat?.compliance :'0'}}</span>
                </div>
            </div>

            <div class="header-col-5">
                <div class="header-col-5-1">
                    <span></span>
                </div>

                <div class="header-col-5-2">
                    <p class="content-l bolder primary-texts py-2 bold-text">{{rulevarservice.ruleMeta.headers[4]}}</p>
                    <span class="warning-text span-l">{{rulevarservice.ruleStat?.ruleStat?.mitre ?
                        rulevarservice.ruleStat?.ruleStat?.mitre : '0'}}</span>
                </div>
            </div>
        </div>
    </div> -->

    <div  class="body-wrapper px-5 pb-5 radius-s">
        <div class="body-top py-3 pl-5">
            <div class="body-top-col-1" >
                <!-- <div #Orgin class="create selectable-text enable-action" (click)="openSourceMenu_click(menu,Orgin)"> -->
                <div #Orgin class="create selectable-text enable-action" (click)="opencreateintel()" hasPermission [hasPermissionModule]="sharedService.moduleNames.intellist" [hasPermissionMode]="'Add'" > 
                    <h2>+</h2><p class="content-l">Create Intel List</p></div>
                <ng-template #menu>
                    <div class="source-container content-m primary-text white-bg dropdown-shadow">
                        <!-- <p *ngFor="let options of rulevarservice.types ">{{options}}</p> -->
                        <ng-container *ngFor="let option of rulevarservice.types">
                            <p (click)="clickcreate(option)"  class="m-0 hover-bg">{{option.disp}}</p>
                        </ng-container>
                        <!-- <p (click)="clickcreate(rulevarservice.types[0])"  class="m-0 hover-bg">{{rulevarservice.types[0].disp}}</p>
                        <p (click)="clickcreate(rulevarservice.types[1])"  class="m-0 hover-bg">{{rulevarservice.types[1]}}</p>
                        <p (click)="clickcreate(rulevarservice.types[2])"  class="m-0 hover-bg">{{rulevarservice.types[2]}}</p>
                        <p (click)="clickcreate(rulevarservice.types[3])"  class="m-0 hover-bg">{{rulevarservice.types[3]}}</p>
                        <p (click)="clickcreate(rulevarservice.types[4])"  class="m-0 hover-bg">{{rulevarservice.types[4]}}</p> -->
                    </div>
                </ng-template>
                
            </div>
            <div class="body-top-col-2">
                <div class="custom-search">
                    <img class="icon-s" src="assets/settings/search-small.svg">
                    <input type="search" placeholder="Type to search here"
                        [formControl]="rulevarservice.inteltablesearch" class="placeholders input-border input-m">
                </div>
            </div>

            <div class="body-top-col-3">
                <img class="icon-s" src="assets/rule/left-arrow.svg" (click)="intelpaginationTable_click(-1)"
                    [ngClass]="rulevarservice.intelpagenumber | disableAction:this.rulevarservice.intelpagelength:-1:mat_spinner_ruleList_state">
                <p class="primary-texts content-m">{{rulevarservice.intelpagenumber}} of {{this.rulevarservice.intelpagelength}}</p>
                <img  class="icon-s"src="assets/rule/right-arrow.svg" (click)="intelpaginationTable_click(1)"
                    [ngClass]="rulevarservice.intelpagenumber | disableAction:this.rulevarservice.intelpagelength:1:mat_spinner_ruleList_state">
            </div>

            <div class="body-top-col-4">
                <ng-container *ngFor="let pagedat of rulevarservice.commonData.pagination | keyvalue">
                    <p class="pagination-items-per-page content-m my-5 primary-texts">{{pagedat.key}}</p>
                    <app-overlay-select  [formControl]="rulevarservice.intelitemperpage"
                        [data]="pagedat.value"  fontsize="input-m">
                    </app-overlay-select>
                </ng-container>

            </div>
            <div class="refresh-button"
                [ngClass]="mat_spinner_ruleList_state ? 'disable-action':'enable-action'">
                <img class="tooltip-enable icon-s" tooltip="Refresh" src="assets/rule/refresh-data.svg" (click)="refreshRuletable()">
            </div>
        </div>

        <div   class="body-bottom pl-5">

            <ng-container *ngIf="!mat_spinner_ruleList_state">

                <ng-container *ngIf="rulevarservice.intelList.length;">
                    <!-- else noDataAvaible -->
                    <table>
                        <thead>
                            <tr >
                                <ng-container *ngFor="let header of rulevarservice.intel_tableHeaders">
                                        <th [ngClass]="{'rule-severity':header==='SEVERITY'}">{{header}}</th>
                                        
                                </ng-container>
                                <th></th>
                                <!-- <th>{{rulevarservice.ruleMeta.tableHeaders[0]}}</th>
                                <th>{{rulevarservice.ruleMeta.tableHeaders[1]}}</th>
                                <th [ngClass]="'rule-name'">{{rulevarservice.ruleMeta.tableHeaders[2]}}</th>
                                <th>{{rulevarservice.ruleMeta.tableHeaders[3]}}</th>
                                <th>{{rulevarservice.ruleMeta.tableHeaders[4]}}</th>
                                <th>{{rulevarservice.ruleMeta.tableHeaders[5]}}</th>
                                <th>{{rulevarservice.ruleMeta.tableHeaders[6]}}</th>
                                <th [ngClass]="'rule-severity'">{{rulevarservice.ruleMeta.tableHeaders[7]}}
                                </th> -->
                            </tr>
                        </thead>

                        <tbody >
                            <ng-container  *ngFor="let ruleDetail of rulevarservice.intelList | custompagination :rulevarservice.intelpagenumber:rulevarservice.intelitemperpage.value">
                                <!-- <ng-container *ngIf="ruleDetail.status == 1"> -->
                                    <tr >
                                        <!-- <td (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id)">{{ruleDetail.list_id}}</td> -->
                                        <td  (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id,ruleDetail.list_type)">{{ruleDetail.list_name}}</td>
                                        <td  (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id,ruleDetail.list_type)">{{rulevarservice.platformMap[ruleDetail.platform]}}</td>
                                        <td  (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id,ruleDetail.list_type)">{{ruleDetail.list_type}}</td>
                                        <td  #manualImportOrigin (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id,ruleDetail.list_type)">{{formatDate(ruleDetail.created_time)}}</td>
                                        <td  (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id,ruleDetail.list_type)">{{timeformat(ruleDetail.ttl,ruleDetail.ttl_unit)}}</td>
                                        <td  (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id,ruleDetail.list_type)">{{timeformat(ruleDetail.learning_period,ruleDetail.learning_unit)}}</td>
                                        <td  (click)="intelEditClick(ruleDetail.listname,ruleDetail.list_id,ruleDetail.list_type)">{{ruleDetail.total_rows ? ruleDetail.total_rows : '-'}}</td>
                                        
                                        <td #orgin class="options-td">
                                            <div class="options"> 
                                              <div class="create selectable-text enable-action" [ngClass]="ruleDetail.list_type === 'Built-in'?'permission-denied':''" (click)="openSourceMenu_click(menu,orgin)" hasPermission
                                              [hasPermissionModule]="sharedService.moduleNames.intellist" [hasPermissionMode]="'Add'">
                                                <img class="icon-s"  src="../../assets/widgets/more-options.svg"></div>
                                                <ng-template #menu>
                                                  <div class="source-container-2 content-m primary-text white-bg dropdown-shadow" [ngStyle]="{'width':'fit-content','right':'2vw','position':'relative'}" >
                                                    <ng-container *ngFor="let option of rulevarservice.intelListOptions">
                                                      <p (click)="intelOptionClick(option,ruleDetail,manualImportOrigin)" [ngStyle]="{'white-space':'nowrap'}" [ngClass]=" option.value ==='import_manually' || option.value ==='import_file' || option.value ==='browse' || option.value ==='download' || option.value ==='delete' ? 'enable-action hover-bg opacity-high':'disable-action opacity-low permission-denied'"  class="m-0">{{option.disp}}</p>
                                                    </ng-container>
                                                   </div>
                                                </ng-template>
                                            </div>
                                          </td>
                                        <!-- <td (click)="openEdit_click(ruleDetail?.ruleId,ruleDetail.lookbackprogress,ruleDetail.status,$event,ruleDetail?.ruleType,ruleDetail.is_builtin)"> -->
                                            <!-- status image -->
                                            <!-- <img class="active-status" -->
                                                <!-- [src]="ruleDetail.status == 1 ?'assets/rule/greenTick.svg': ruleDetail.status == 3 ? 'assets/rule/yellowTick.svg':ruleDetail.status == 2 ?'assets/rule/yellowDisabled.svg':'assets/rule/greyTick.svg'"> -->
                                        <!-- </td> -->
                                        <!-- <td [tooltip]="ruleDetail?.ruleId" (click)="openEdit_click(ruleDetail?.ruleId,ruleDetail.lookbackprogress,ruleDetail.status,$event,ruleDetail?.ruleType,ruleDetail.is_builtin)">{{ruleDetail.ruleId}}</td> -->
                                        <!-- <td [ngClass]="'rule-name'" (click)="openEdit_click(ruleDetail?.ruleId,ruleDetail.lookbackprogress,ruleDetail.status,$event,ruleDetail?.ruleType,ruleDetail.is_builtin)"
                                            [tooltip]="ruleDetail?.ruleName"> -->
                                            <!-- {{ruleDetail?.ruleName}}</td> -->
                                        <!-- <td [tooltip]="rulevarservice.platformMap[ruleDetail.platform]" (click)="openEdit_click(ruleDetail?.ruleId,ruleDetail.lookbackprogress,ruleDetail.status,$event,ruleDetail?.ruleType,ruleDetail.is_builtin)">{{rulevarservice.platformMap[ruleDetail.platform]}}</td> -->
                                        <!-- <td [tooltip]="ruleDetail.ruleType" (click)="openEdit_click(ruleDetail?.ruleId,ruleDetail.lookbackprogress,ruleDetail.status,$event,ruleDetail?.ruleType,ruleDetail.is_builtin)">{{ruleDetail.ruleType | titlecase}}</td> -->
                                        
                                            <!-- <td class="tooltip-enable" [tooltip]="ruleDetail.taglist" >
                                                <ng-container *ngIf="ruleDetail.tags_count">{{ruleDetail.tags_count}} </ng-container>
                                            </td> -->

                                            <!-- <td #menuOrgin>
                                                <ng-container *ngIf="ruleDetail.tags_count">
                                                    <button class="tagCount content-m white-text enable-action border-none secondary-bg radius-l" (click)="openSourceMenu_click(menu,menuOrgin)">
                                                        {{ruleDetail.tags_count}} 
                                                    </button>
                                                </ng-container>
                                            </td> -->
                                            <!-- <ng-template #menu>
                                                <div class="source-container p-3 radius-m dropdown-shadow white-bg">
                                                    <p class="content-m primary-text" *ngFor="let menu of ruleDetail.taglist">{{menu}}</p>
                                                </div>
                                            </ng-template> -->
                                       



                                        <!-- <td class="tags-chip-group" *ngIf="ruleDetail.compliance; else noTag"
                                            [tooltip]="ruleDetail?.compliance | regulateTags : rulevarservice.commonData.tags | combinearray">
                                            <ng-container
                                                *ngFor="let chips of ruleDetail?.compliance | regulateTags : rulevarservice.commonData.tags | limitArrayValue :1; index as i">
                                                <span class="tag-chip span-s secondary-texts p2 radius-l mr-2 mb-2 border-report">{{chips}}</span>
                                            </ng-container>
                                            <span class="tags-more span-m secondary-texts"
                                                *ngIf="ruleDetail?.compliance.length >1">...+{{ruleDetail?.compliance.length-1}}
                                            </span>
                                        </td>
                                        <td class="tags-chip-group" *ngIf="ruleDetail.mitreattack; else noTag"
                                            [tooltip]="ruleDetail?.mitreattack | regulateTags : rulevarservice.commonData.tags | combinearray">
                                            <ng-container
                                                *ngFor="let chips of ruleDetail?.mitreattack | regulateTags : rulevarservice.commonData.tags | limitArrayValue :1; index as i">
                                                <span class="tag-chip span-s secondary-texts p2 radius-l mr-2 mb-2 border-report">{{chips}}</span>
                                            </ng-container>
                                            <span class="tags-more secondary-texts span-m"
                                                *ngIf="ruleDetail?.mitreattack.length >1">...+{{ruleDetail?.mitreattack.length-1}}
                                            </span>
                                        </td> -->
                                        <!-- <td (click)="openEdit_click(ruleDetail?.ruleId,ruleDetail.lookbackprogress,ruleDetail.status,$event,ruleDetail?.ruleType,ruleDetail.is_builtin)">
                                            <div class="no-icon">
                                                <div class="severity-code">
                                                    <span class="severity-color-code"
                                                        [ngClass]="ruleDetail?.severity">
                                                    </span>
                                                    <span class="severity-value-code" [tooltip]="ruleDetail?.severity">
                                                        {{ruleDetail?.severity |titlecase}}
                                                    </span>
                                                </div>
                                            </div>
                                        </td> -->
                                        <!-- <td class="hover">
                                        
                                            <div class="is-icon">
                                                <div
                                                    [ngClass]="ruleDetail.lastlookbackstatus == -1 ? 'rule-icons':'rule-icons-with-lookbackresult'"> -->
                                                    <!-- <ng-container
                                                        *ngIf="ruleDetail.status == 0 || ruleDetail.status == 1"> -->
                                                        <!-- <img hasPermission
                                                        [hasPermissionModule]="sharedService.moduleNames.rule" [hasPermissionMode]="'Edit'" [ngClass]="ruleDetail.lookbackprogress ? 'editrule-click' : 'disable-editrule-click'"
                                                            [tooltip]="rulevarservice.ruleMeta.lookbackmeta.labels[1]" class="tooltip-enable"
                                                            (click)="openEdit_click(ruleDetail?.ruleId,ruleDetail.lookbackprogress,ruleDetail.status,$event,ruleDetail?.ruleType,ruleDetail.is_builtin)"
                                                            src="assets/rule/edit-row.svg">
                                                        <div *ngIf="ruleDetail.status" class="lookback-icon"
                                                            [ngClass]="ruleDetail.lookbackprogress == 0 ? 'playback-rule-icon-incomplete': 'playback-rule-icon-complete'"> -->
                                                            <!-- *ngIf="ruleDetail.alertType !='frequency'" -->
                                                            <!-- <ng-container>
                                                                <img class="lookback-rule-icon tooltip-enable" tooltip="lookback"
                                                                    (click)="openPlaybackRule(ruleDetail?.ruleId,ruleDetail?.platform,ruleDetail?.lookbackprogress,$event)"
                                                                    [src]="ruleDetail.lookbackprogress == 0 ? 'assets/rule/lookback-process.svg': ruleDetail.lookbackprogress == -1 ? 'assets/rule/lookback.svg':'assets/rule/preview.svg'"
                                                                    [tooltip]="ruleDetail.lookbackprogress == -1 ? rulevarservice.ruleMeta.lookbackmeta.labels[2]:ruleDetail.lookbackprogress != 0 ? rulevarservice.ruleMeta.lookbackmeta.labels[3]:''">
                                                                <span
                                                                    *ngIf="ruleDetail.lookbackprogress == 0">{{rulevarservice.ruleMeta.lookbackmeta.labels[0]}}</span>
                                                            </ng-container>
                                                        </div>
                                                        <img *ngIf="ruleDetail.lastlookbackstatus != -1"
                                                            [tooltip]="ruleDetail.lastlookbackstatus ? rulevarservice.ruleMeta.lookbackmeta.labels[5]:rulevarservice.ruleMeta.lookbackmeta.labels[6]"
                                                            class="last-lookback-status tooltip-enable"
                                                            [src]="ruleDetail.lastlookbackstatus ? 'assets/rule/status-success.svg':'assets/rule/status-fail.svg'"> -->
                                                    <!-- </ng-container> -->
                                                    <!-- <ng-container
                                                        *ngIf="ruleDetail.status == 2 || ruleDetail.status == 3">
                                                        <span class="rule-postmsg">{{ruleDetail.status == 3 ?
                                                            'Activation Pending':'Deactivation Pending'}}</span>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </td> -->
                                        <ng-template #noTag>
                                            <td class="no-tags"> {{rulevarservice.ruleMeta.noDatamsg[1]}} </td>
                                        </ng-template>
                                    </tr>
                                <!-- </ng-container> -->
                            </ng-container>
                        </tbody>

                        <ng-template #enrichPopup let-dialogRef="dialogRef">
                          
                            <mat-dialog-content class="p-10 pt-8 pb-7 ">
                                <p class="content-xl primary-text ">All columns in this list are enrichable and cannot be edited.</p>
                            </mat-dialog-content>
                          
                            <mat-dialog-actions class="p-0 pr-7"  align="end">
                                <button mat-button class="submit" (click)="enrichYes()">OK</button>
                            </mat-dialog-actions>

                        </ng-template>

                        <ng-template #deletePopUp let-dialogRef="dialogRef">
                          
                            <mat-dialog-content class="p-9 pt-8 pb-7 m-0">
                                <p class="content-xl primary-text ">This list is referenced and cannot be deleted.</p>
                            </mat-dialog-content>
                          
                            <mat-dialog-actions class="p-0 pr-7"  align="end">
                                <button mat-button class="submit" (click)="deleteYes()">OK</button>
                            </mat-dialog-actions>

                        </ng-template>
                        
                        <ng-template #deleteConfirmation let-dialogRef="dialogRef">
                          
                            <mat-dialog-content class="p-9 pt-8 pb-7 m-0">
                                <p class="content-xl primary-text ">Do you really want to delete this list ?</p>
                            </mat-dialog-content>
                          
                            <mat-dialog-actions class="p-0 pr-7"  align="end">
                                <button mat-button class="cancel" (click)="deleteConfirmNo()">No</button>
                                <button mat-button class="submit" (click)="deleteConfirmYes()">Yes</button>
                            </mat-dialog-actions>

                        </ng-template>
                        
            
                    </table>
                </ng-container>
                <ng-container *ngIf="!rulevarservice.intelList.length">
                    <div class="no-result-container content-l bolder">
                        <img src="/assets/rule/empty-data.svg">
                        <div class="no-result">
                            {{rulelisterrorinsatnce.status? rulelisterrorinsatnce.errmsg
                            :rulevarservice.ruleMeta?.noDatamsg[0]}}
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="mat_spinner_ruleList_state">
                <div class="body-bottom-spinner">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
            <ng-container *ngIf="mat_spinner_download">
                <div class="body-download-spinner">
                    <mat-spinner class="download-spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
    </div>
</div> 